<template>
  <div style="height: 100vh;display: flex;justify-content: center;align-items: center;">
    <div style="">
      <van-cell-group>
        <van-field required v-model="mobile" type="tel" label="手机号：" placeholder="请输入手机号"/>
      </van-cell-group>
      <div style="height: 20px;"></div>
      <van-button type="primary"  @click="login" block>登录应用</van-button>
    </div>
    <van-notify v-model="show" type="danger">
      <van-icon name="bell" style="margin-right: 4px;" />
      <span>{{msg}}</span>
    </van-notify>
  </div>
</template>

<script>
  export default {
    name: "login",
    data() {
      return {
        mobile: '',
        show: false,
        msg: ''
      }
    },
    created() {
      var mobile = localStorage.getItem("xq-mobile");
      var appid = localStorage.getItem("xq-appid");
      if (mobile && appid){
        this.$router.push("/")
      }
    },
    methods:{
      getQueryObject(url) {
        const requestStr = location.search.slice(1)
        const requestArray = requestStr.split('&')
        const obj = {}
        requestArray.forEach(item => {
          const index = item.indexOf('=')
          const key = item.slice(0, index)
          const value = item.slice(index + 1)
          obj[key] = value
        })
        return obj
      },
      login(){
        this.$post(this.API1url.API.verifyMobile, {
          shopid: this.getQueryObject().shopid,
          mobile: this.mobile
        }).then(res => {
          // console.log(res)
          if (res.code == 0) {
            localStorage.setItem("xq-mobile", this.mobile)
            localStorage.setItem("xq-appid", res.data)
            this.popupShow = false;
            var apiName = this.API1url.API;
            this.$get(apiName.Color,{
              appid: res.data,
              mobile: this.mobile
            }).then(res=>{
              if(res.code == '0000'){
                // console.log(res)
                // res.data.rgb = 'rgb(253, 1, 66)'   961d361e97db42178b459c3eac7380da
                // res.data.rgba = 'rgba(253, 1, 66,.2)'
                localStorage.setItem('bakColor', JSON.stringify(res.data));
                this.$router.push("/")
              }
            }).catch(res=>{
              Toast.fail('加载失败');
            })

          }else{
            this.show = true;
            this.msg = res.msg;
            setTimeout(() => {
              this.show = false;
            }, 2000);
          }
        })
        // localStorage.setItem("xq-mobile", this.mobile);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login.vue